import React from 'react'

const Obstetric_And_Gynaecology = () => {
  return (
    <>
      <div id='Topmargin1' >
        <div className='about_banner'>
          <img src='gynecology.jpeg' className='about_image' alt=''></img>
        </div>
      </div>
      <div className='container Service_Content'>
        <h2>Obstetric & Gynaecology</h2>
        <img src='gynecology_image2.png' alt=''></img>
        <p>We take care of every precaution. Because life’s better when you’re covered.</p>
        <h3>PRE-PREGNANCY COUNSELLING</h3>
        <p>We will answer any small question you have and get you ready for a beautiful ride. You may have several questions about pregnancy, the do’s and don’ts, the diet to follow, the importance of physical activities, and so on. We understand your nervousness and fear as you prepare to take this important step in your life. No worries, our doctors are also known for their counselling sessions, in which they will explain all of the issues, as well as the steps to take and the precautions to take.</p>
        <img src='gynecology_image1.png' alt=''></img>
        <h3>NORMAL DELIVERIES</h3>
        <p>Normal deliveries are healthier when compared to a c- section delivery. Normal delivery is associated with less risk of infection for mother and children. Normal delivery stimulates lactation because the birthing process activates numerous natural mothering hormones. Babies are born with a lower risk for respiratory problems since labour contractions help prepare baby’s lungs for breathing. Our doctors are very experienced with a great success rate in normal deliveries.</p>
        <img src='gynecology_image3.png' alt=''></img>
        <h3>FAMILY PLANNING</h3>
        <p>In this modern era, family planning is the most important aspect to be followed. Not only the economical aspects but also the health should be taken into consideration. We have the best doctors in town who will educate you about the need and importance of family planning. It is necessary to have a brief talk with doctors before jumping into any conclusions. We care for your health first!</p>
        <img src='gynecology_image4.png' alt=''></img>
        <h3>SCREENING SERVICES</h3>
        <p>Screening tests are helpful to detect any problems at an earlier stage. Through this, they get a chance to analyse the problems at an earlier stage so that more effective treatment can be given also the decisions regarding any can be taken at the earliest. Some of the screening tests include –</p>
        <ul>
          <li>Early pregnancy scan</li>
          <li>Nuchal translucency scan</li>
          <li>Early blood tests</li>
          <li>Chorionic villus sampling</li>
          <li>Non-invasive prenatal testing</li>
        </ul>
        <p>We provide all of the screening tests to the best of your health. We also will suggest you any treatments only when the need arises. We will be ahead of you when it comes to the health of you and your baby. Our doctors are very experienced and pronounced in their fields.</p>
        <img src='gynecology_image5.png' alt=''></img>
        <h3>FEMALE RELATED CANCER</h3>
        <p>Cancer can be explained as when cells in the body grow out of control. When cancer starts in the reproductive organs it is called gynecologic cancer. The five main types of cancer are</p>
        <ul>
          <li>Cervical</li>
          <li>Ovarian</li>
          <li>Uterine</li>
          <li>Vaginal</li>
        </ul>

        <p>With the help of screening tests, cervical cancer can be diagnosed and it makes the treatment most effective as it can be found out at the earliest. Our doctors will educate you about the symptoms and signs before hand as remaining all depends only on observation; they cannot be diagnosed through screening tests. The treatment for all the above types is different according to the type and how far it has spread.</p>
        <img src='gynecology_image6.png' alt=''></img>
      </div>

    </>
  )
}

export default Obstetric_And_Gynaecology